import { FC } from 'react';

import { CoOwner } from 'types';

import TableBody from 'modules/_shared/Table/components/TableBody';

import CoOwnersTableRow from './CoOwnersTableRow';
import { useEncumbranceDetailsPage } from '../context/EncumbranceDetailsPageContext';

const CoOwnersTableBody: FC = () => {
  const { data } = useEncumbranceDetailsPage();

  const hasData = data.coOwners?.length > 0;

  const rows = data.coOwners!.map((coOwner: CoOwner, index: number) => (
    <CoOwnersTableRow
      // eslint-disable-next-line react/no-array-index-key
      key={`co-owner-row-${index}`}
      index={index}
      coOwner={coOwner}
    />
  ));

  return <TableBody hasData={hasData} content={rows} noDataMessage="" />;
};

export default CoOwnersTableBody;
